export default "__VITE_ASSET__Dlpj8AjL__"